import type { OnboardingStatus } from "@/features/home/onboarding/schemas/onboarding-status.schema";

interface ImportOnboardingVisibilityInput {
  canLaunchActions: boolean;
  autoClosed: boolean;
  snoozed: boolean;
  isWorkspaceHome?: boolean;
  onboardingStatus: OnboardingStatus | undefined;
}

export function shouldShowImportOnboarding({
  canLaunchActions,
  autoClosed,
  snoozed,
  isWorkspaceHome = true,
  onboardingStatus,
}: ImportOnboardingVisibilityInput): boolean {
  if (!canLaunchActions || autoClosed || snoozed || !isWorkspaceHome || !onboardingStatus)
    return false;
  // The modal is a 3-step hub (import, kudos, check-in), so it stays available
  // until every step is done, not just the first one.
  return onboardingStatus.applicable && onboardingStatus.complete === false;
}
